import * as React from 'react';
import * as TreeTypeRepository from '../../Repository/TreeTypeRepository';
import * as ContractRepository from '../../Repository/ContractRepository';
import TreeForm from './TreeForm';
import Loader from '../../Component/Loader/Loader';
import { message, PageHeader, Result, Button } from 'antd';
import { TreeData } from 'tree-wallet-client';
import { default as Page, PageProps } from '../../Component/Page/Page';
import { GlobalContext } from '../../Contexts/GlobalContext';
import { withReactRouter } from "../../Helper/HooksHelper";
import { Navigate } from 'react-router-dom';
import { capitalize } from "../../Helper/DataHelper";
import { UserRoles } from "../../Repository/UserRepository";
import { genericError } from '../../Helper/BannerMessages';
import { logout } from '../../Service/AuthService';

interface FormPageState {
  treeData?: TreeData[];
  loading: boolean;
}

export const allowedRoles = [
  ContractRepository.roles.TreePlanter,
  UserRoles.CompensationProgram
];

class FormPage extends React.Component<PageProps, FormPageState> {
  static contextType = GlobalContext;
  declare context: React.ContextType<typeof GlobalContext>;

  constructor(props: PageProps) {
    super(props);

    this.state = {
      treeData: undefined,
      loading: true,
    };
  }

  async componentDidMount() {
    const { contract, user } = this.context;

    if (user && contract) {
      try {
        await TreeTypeRepository.getTreeTypesList({
          params: { contractId: contract && contract.id, userId: user.id },
          successCallback: (treeData: any) => {
            this.setState({ treeData: treeData, });
          },
          errorCallback: (error: any) => {
            message.error(genericError(String(error)));
          }
        })
      } catch (error) {
        // The errorCallback above already said it: the loader still has to come down
        console.error('could not read the tree types of the contract', { error });
      }
    }

    this.setState({ loading: false });
  }

  render() {
    const { contract, user } = this.context;
    const { treeData, loading } = this.state;
    const pageProps = { ...this.props, loading }

    if (!user) {
      return <Navigate to={"/login"} />
    }

    if (!contract) {
      return (
        <Page
          {...pageProps}
          title={capitalize(user?.firstName)}
          loading={false}
          allowedRoles={allowedRoles}
        >
          <Result
            status="error"
            title={"No contract defined"}
            extra={<Button type="primary" onClick={logout}>Logout</Button>}
          />
        </Page>
      );
    }

    return (
      <GlobalContext.Consumer>
        {({ contract, user }) => {
          return (
            <Page {...pageProps} title={capitalize(user?.firstName)} allowedRoles={allowedRoles}>
              {!loading && user && contract
                ? <TreeForm 
                    user={user} 
                    treeData={treeData} 
                    contract={contract} 
                    isPlanterValidator={true} // Enable planter validator mode for all planters
                  />
                : <PageHeader className="site-page-header" title={<Loader />} />
              }
            </Page>
          )
        }}
      </GlobalContext.Consumer>
    );
  }
}

export default withReactRouter(FormPage);